import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { routes } from './routes/routes';
import { AuthProvider } from './contexts/AuthContext';
import { theme } from './theme/theme';
import SnackbarWrapper from './layout/SnackbarWrapper';
import { AuthEventListener } from './contexts/AuthEventListener';

const router = createBrowserRouter(routes);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarWrapper>
        <AuthProvider>
          <AuthEventListener />
          <RouterProvider router={router} />
        </AuthProvider>
      </SnackbarWrapper>
    </ThemeProvider>
  );
}

export default App;
